<template>
  <split-panel-page :scroll="false" :showRight="showHelp">
    <content-nav-bar class="content-nav-bar">
      <h5 class="is-size-4 has-text-centered level-item">Create Analytic</h5>
      <a v-on:click="submit()" class="add button level-item">
        <i class="far fa-save"></i>
        Save
      </a>
      <p v-if="validMessage" class="message level-item">{{ validMessage }}</p>
      <loader class="level-item" :showLoader="showLoader">Saving Analytic</loader>
      <template slot="right">
        <a @click="showHelp = !showHelp" class="help-toggle">
          {{ helpMessage }} <i class="far fa-life-ring"></i>
        </a>
      </template>
    </content-nav-bar>
    <div class="full-height-scroll">
      <analytic-form
        v-if="internalAnalytic"
        :analytic.sync="internalAnalytic"
        v-on:update:analyticEventDef="eventDef = $event">
      </analytic-form>
    </div>
    <template slot="right">
      <content-nav-bar>
        <h5 class="is-size-4 has-text-centered level-item">Analytic Documentation</h5>
      </content-nav-bar>
      <analytic-help-panel
        v-if="eventDef"
        :def="eventDef"
        v-bind:class="{ 'hide-help': !showHelp }"
        class="help-section full-height-scroll">
      </analytic-help-panel>
    </template>
  </split-panel-page>
</template>

<script>
import analyticMixin from '@/mixins/analytic';
import AnalyticForm from '@/components/analytics/forms/AnalyticForm.vue';
import AnalyticHelpPanel from '@/components/analytics/AnalyticHelpPanel.vue';
import SplitPanelPage from '@/components/SplitPanelPage.vue';
import ContentNavBar from '@/components/ContentNavBar.vue';
import Loader from '@/components/Loader.vue';

export default {
  name: 'AnalyticCreate',
  mixins: [analyticMixin],
  components: {
    AnalyticForm,
    AnalyticHelpPanel,
    SplitPanelPage,
    ContentNavBar,
    Loader,
  },
  async beforeMount() {
    if (this.$route.query.b) {
      const baseAnalytic = await this.$store.dispatch('primary/getAnalytic', {
        uuid: this.$route.query.b,
      });
      this.internalAnalytic = this.generateInternalAnalytic(baseAnalytic, false);
      this.internalAnalytic.name = `${this.internalAnalytic.name} Copy`;
    } else {
      this.internalAnalytic = this.$typeDefs.configs.analytic;
    }
  },
  data() {
    return {
      eventDef: null,
      showHelp: true,
      validMessage: null,
      internalAnalytic: null,
      showLoader: false,
    };
  },
  computed: {
    helpMessage() {
      if (this.showHelp) {
        return 'Hide Help';
      }
      return 'Show Help';
    },
  },
  methods: {
    async submit() {
      this.showLoader = true;
      const analytic = await this.$store.dispatch('primary/createAnalytic', this.internalAnalytic);
      this.showLoader = false;
      if (analytic) {
        this.$router.push({ name: 'analytics.index.detail', params: { id: analytic.uuid } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.full-height-scroll {
  flex-grow: 1;
  height: 100%;
  padding-bottom: 2rem;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
